import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  CLEAR_ITINERARY_CHANGE_ROUTE,
  CLEAR_ITINERARY_CHANGE_ROUTES,
  FLAG_GETTING_ITINERARY_CHANGE_ROUTES,
  FLAG_ITINERARY_CHANGE_ROUTE_ACTIVITY,
  GET_ITINERARY_CHANGE_ROUTE,
  GET_ITINERARY_CHANGE_ROUTES,
} from '../../../actions/types';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case FLAG_GETTING_ITINERARY_CHANGE_ROUTES:
      return state.setIn(['all', 'loading'], payload);
    case GET_ITINERARY_CHANGE_ROUTES:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_ITINERARY_CHANGE_ROUTES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_ITINERARY_CHANGE_ROUTE_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_ITINERARY_CHANGE_ROUTE:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_ITINERARY_CHANGE_ROUTE:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
